<script>
import {api} from "@/modules/api";
import StatusDelivery from "@/components/ordering/details/StatusDelivery.vue";

export default {
  name: 'ItemListOrder',
  components: {StatusDelivery},
  props: {
    order: {
      type: Object,
      required: true
    }
  },
  computed: {
    getNumberQuantity () {
      let totalQuantity = 0
      Object.values(this.order.productsCart).map((item) => {
        totalQuantity += item.quantity
      })

      return totalQuantity
    },
    getPrice () {
      let total = 0
      Object.values(this.order.productsCart).map((item) => {
        total += item.quantity * item.products.price
      })
      return total
    }
  },
  methods: {
    nextStep () {
      api.orders.nextStep(this.order.id, this.order.Workflow.at(-1).step).then(() => {
        this.emitter.emit('load-data', true)
      })
    }
  }
}
</script>

<template>
  <tr v-if="order.productsCart" class="border-b">
    <th scope="row" class="px-4 py-3 font-medium text-gray-900 whitespace-nowrap">
      {{ order.numberOrder }}
    </th>
    <td class="px-4 py-3">
      {{ order.users.lastname }} {{ order.users.firstname }}
    </td>
    <td class="px-4 py-3">
      x{{ getNumberQuantity }}
    </td>
    <td class="px-4 py-3">
      {{ getPrice }}€
    </td>
    <td class="px-4 py-3">
      <status-delivery :workflows="order.Workflow" :show-status="false" />
    </td>
    <td class="flex">
      <router-link :to="{name: 'app_order_admin_detail', params: {id: order.id}}" class="mb-2 me-2 rounded-lg bg-white border-2 border-primary-700 text-primary-300 px-5 py-2.5 text-sm font-medium hover:text-white hover:bg-primary-700 focus:outline-none">
        Suivie de commande
      </router-link>
      <button v-if="order.Workflow.at(-1).step !== 'step-3'" @click="nextStep" class="mb-2 me-2 rounded-lg bg-primary-700 px-5 py-2.5 text-sm font-medium text-white hover:bg-primary-800 focus:outline-none">
        Etape suivante
      </button>
    </td>
  </tr>
</template>
